import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Button } from '~/components/granular/button';
import type { ButtonProps } from '~/components/granular/button';
import { classNames } from '~/utils';

/* -------------------------------------------------------------------------------------------------
 * Building blocks for the "Back" row at the top of drill-in content (combo filters, drill-down menus)
 * -----------------------------------------------------------------------------------------------*/

export function BackButtonContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={classNames('border-b border-neutral-200 px-4 py-2', className)}>{children}</div>;
}

export const BackButtonControl = forwardRef<HTMLButtonElement, Omit<ButtonProps, 'appearance' | 'leftIcon' | 'size'>>(
  (props, forwardedRef) => (
    <Button appearance="text" leftIcon="ArrowLeftSIcon" ref={forwardedRef} size="small" {...props} />
  ),
);
